import React from 'react';
import { Content } from './shared';

const CignaGlasses = () => (
  <Content>
    Near sighted, far sighted, and everything in between. Enjoy discounts on the frames and lenses
    you need at select providers.
    <ol>
      <li>Log into your Cigna account.</li>

      <li>
        Go to Wellness {'>'} Healthy Rewards-Discount Programs {'>'} Vision Discounts.
      </li>
    </ol>
  </Content>
);

export default CignaGlasses;
